import * as helper from './../../../../VX/View/Assets/Js/helper';

export function waitingOverlay() {
	const body = document.querySelector('body');
	const overlay = '<div id="waitingOverlay">' +
		'<div id="waitingIndicator">Loading <div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>' +
		'</div>';
	body.appendChild(helper.stringToHtml(overlay));
}
